import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { SITE_COLOR } from "src/domains/shared/constants/styles/site";
import { MANUAL_UI_LABEL_STYLES } from "./manualStyles";

/**
 * 매뉴얼 문구 안 꾸밈 — `<ui>바꾸기</ui>` 는 화면의 단추·칸 이름, `<a href="#t-pf-open">…</a>` 는 다른 절로 가는 링크.
 * 문구는 우리 번역 리소스뿐이라 이 두 태그만 읽고 나머지는 글자 그대로 둔다.
 */
const TAG_PATTERN = /(<ui>.*?<\/ui>|<a href="#[\w-]+">.*?<\/a>)/;
const LINK_PATTERN = /^<a href="(#[\w-]+)">(.*)<\/a>$/;

const LINK_STYLES = { fontWeight: 600, color: SITE_COLOR.blueDark } as const;

export function ManualText({ text }: { text: string }): ReactNode {
  return text.split(TAG_PATTERN).map((part, index) => {
    if (part.startsWith("<ui>")) {
      return (
        <Box component="span" key={index} sx={MANUAL_UI_LABEL_STYLES}>
          {part.slice(4, -5)}
        </Box>
      );
    }
    const link = LINK_PATTERN.exec(part);
    if (link) {
      return (
        <Box component="a" key={index} href={link[1]} sx={LINK_STYLES}>
          {link[2]}
        </Box>
      );
    }
    return part;
  });
}

/** 검색 색인용 — 꾸밈 태그를 걷은 글 */
export const plainManualText = (text: string) => text.replace(/<[^>]+>/g, "");
